// extracted by mini-css-extract-plugin
export var deleteModal = "_fo-0";